import { StoreSchema } from '../../types/store'

export const selectLicenseState = (store: StoreSchema) => store.licence